import * as React from "react"
import { Flex } from "@chakra-ui/react"
import MediaPlayer from "../../_mediaPlayer"

import {
  ScreensContainer,
  ContainerMuteUserButton
} from "./mobile-prev-speaker-steams.styled"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { activeSpeakerSelector } from "../../../../recoil/atoms/activeSpeaker"
import { MuteUserButton } from "../mobile-local-buttons/mute-user-button"
import { MobilePrevSpeakerStreamProps } from "./mobile-prev-speaker-steams.interface"
import { localUserIdAtom } from "../../../../recoil/atoms/users"

const _MobilePrevSpeakerStream: React.FC<MobilePrevSpeakerStreamProps> = ({
  uid,
  key,
  localUserProperties,
  isTablet,
  smallScreenStyling
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const activeSpeaker = useRecoilValue(activeSpeakerSelector)
  const localUserId = useRecoilValue(localUserIdAtom)

  const stylesScreenWithBorder = React.useMemo(() => {
    return {
      ...smallScreenStyling,
      border: `2px solid ${roomStyles.highlighterColor ?? "#000000"}`
    }
  }, [roomStyles.highlighterColor, smallScreenStyling])

  const [isMuteButton, setMuteButton] = React.useState(false)

  React.useEffect(() => {
    if (isMuteButton) {
      let timer = setTimeout(() => {
        setMuteButton(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isMuteButton])

  return (
    <ScreensContainer key={key}>
      {isMuteButton && localUserId !== uid && (
        <ContainerMuteUserButton>
          <MuteUserButton uid={uid} isMainScreen={false} />
        </ContainerMuteUserButton>
      )}
      <Flex
        onTouchStart={e => {
          setMuteButton(prev => !prev)
        }}
      >
        <MediaPlayer
          key={`player-${uid}`}
          uid={uid}
          localUserProperties={localUserProperties}
          styling={
            isTablet && uid === activeSpeaker.uid
              ? stylesScreenWithBorder
              : smallScreenStyling
          }
          isSmallWindow={true}
          isMobileIOS={isTablet ? "false" : "true"}
        />
      </Flex>
    </ScreensContainer>
  )
}

export const MobilePrevSpeakerStream = React.memo(_MobilePrevSpeakerStream)
